'use strict';

var chunkedSplice = require('./chunked-splice.js');

function chunkedPush(list, items) {
  if (list.length) {
    chunkedSplice(list, list.length, 0, items);
    return list;
  }

  return items;
}

module.exports = chunkedPush;